import { deleteApi} from "./api_instance";

export const deleteWishlistItem = async (wishlistId, dispatch) => {
    try {
      const { message } = await deleteApi({
        apiUrl: `/projects/api/my-wishlist/wishlists/${wishlistId}`,
        sendToken: true,
        dispatch,

      });
      return message;
    } catch (error) {
      throw error;
    }
  };